export const landingConstants = {
    subHeading: `### Please select from the options below.`,
    activateCardButtonText: `Activate my card`,
    balanceButtonText: `Balance Check`,
}